export const GlobalConfig = (() => {
  const isProd =
    window.location.href.indexOf("tadesk.app") > -1 ||
    window.location.href.indexOf("vercel.app") > -1;

  // const isProd = false;

    const ISP_ISSUES_DOMAIN = [
      "holiday-sunsation",
      "virikson-holidays",
      "what-a-holiday",
    ];
  
    const HAS_ISP_ISSUES = ISP_ISSUES_DOMAIN.some(domain => window.location.href.includes(domain));
  
    // const PROD_ENGINE_BASE_DOMAIN = HAS_ISP_ISSUES
    //   ? "https://engine-test.clickconnector.app"
    //   : "https://engine.clickconnector.app";

    const PROD_ENGINE_BASE_DOMAIN = HAS_ISP_ISSUES
      ? "https://engine-backup.tadesk.com"
      : "https://engine.tadesk.com";

  // const isProd = true;
  if (isProd) {
    return {
      IS_PROD: true,
      ENGINE_BASE_PATH: `${PROD_ENGINE_BASE_DOMAIN}/api/v1`,
      SOCKET_SERVER: `${PROD_ENGINE_BASE_DOMAIN}/`,
      availableDomains: ["http://localhost:8041"],
      AUTH_APP_URL: "https://auth.clickconnector.io/external-auth-connector",
      UNSPLASH_API_KEY: "xIelu3VTxFdS-OvolI_0L9BMFNJZj-6RehKbdkWV9a4",
    };
  }
  const devHost = window.location.hostname;
  // Optional local override, e.g. VITE_ENGINE_BASE_PATH=http://localhost:5161/api/v1
  const devEngineBasePath = import.meta.env.VITE_ENGINE_BASE_PATH as
    | string
    | undefined;
  return {
    IS_PROD: false,
    ENGINE_BASE_PATH: devEngineBasePath || `http://${devHost}:5160/api/v1`,
    SOCKET_SERVER: `http://${devHost}:5160/`,
    AUTH_APP_URL: "https://auth.clickconnector.io/external-auth-connector",
    // AUTH_APP_URL: "http://localhost:3000/external-auth-connector",
    UNSPLASH_API_KEY: "xIelu3VTxFdS-OvolI_0L9BMFNJZj-6RehKbdkWV9a4",
  };
})();

/** Rewrite stored engine photo URLs (e.g. localhost) to the current ENGINE_BASE_PATH host. */
export function resolveEngineAssetUrl(url: string): string {
  const marker = "/api/v1/location/photos";
  const idx = url.indexOf(marker);
  if (idx === -1) return url;
  return `${GlobalConfig.ENGINE_BASE_PATH}/location/photos${url.slice(idx + marker.length)}`;
}
